import React from 'react';
import { ThemeProvider, StyledEngineProvider, darken, alpha } from '@mui/material/styles';
import { confirmable } from 'react-confirm';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import theme from '../../theme';

const Transition = React.forwardRef(function Transition(props: $TSFixMe, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

type Props = {
  readonly title: string;
  readonly okLabel: string;
  readonly cancelLabel: string;
  readonly show: boolean;
  readonly confirmation: $TSFixMe;
  readonly proceed: () => void;
  readonly dismiss: () => void;
  readonly cancel: () => void;

  // optional custom appearance colors passed from caller
  readonly primaryColor?: string;
  readonly secondaryColor?: string;
};

const Confirmation = ({
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  confirmation,
  show,
  proceed,
  dismiss,
  cancel,
  title = 'Confirmation',
  primaryColor,
  secondaryColor,
}: Props) => {
  const cancelButtonColor = primaryColor!;
  const okButtonColor = secondaryColor!;

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Dialog
          open={show}
          TransitionComponent={Transition}
          onClose={dismiss}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {confirmation}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={cancel}
              disableRipple
              sx={{
                color: cancelButtonColor,
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: darken(cancelButtonColor, 0.08),
                  backgroundColor: alpha(cancelButtonColor, 0.08),
                },
                '&:focus-visible': {
                  color: darken(cancelButtonColor, 0.08),
                  backgroundColor: alpha(cancelButtonColor, 0.08),
                  boxShadow: `0 0 0 3px ${alpha(cancelButtonColor, 0.2)}`,
                  outline: 'none',
                },
                '&:active': {
                  color: darken(cancelButtonColor, 0.14),
                  backgroundColor: alpha(cancelButtonColor, 0.14),
                },
              }}
            >
              {cancelLabel}
            </Button>
            <Button
              onClick={proceed}
              disableRipple
              sx={{
                color: okButtonColor,
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: darken(okButtonColor, 0.08),
                  backgroundColor: alpha(okButtonColor, 0.08),
                },
                '&:focus-visible': {
                  color: darken(okButtonColor, 0.08),
                  backgroundColor: alpha(okButtonColor, 0.08),
                  boxShadow: `0 0 0 3px ${alpha(okButtonColor, 0.2)}`,
                  outline: 'none',
                },
                '&:active': {
                  color: darken(okButtonColor, 0.14),
                  backgroundColor: alpha(okButtonColor, 0.14),
                },
              }}
            >
              {okLabel}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default confirmable(Confirmation);